import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import "./utils/disableConsole";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[PWA] Service Worker kaydı başarılı:', registration);
  },
  onUpdate: (registration) => {
    console.log('[PWA] Yeni sürüm mevcut:', registration);
    // The PWAUpdateNotification component will handle the UI
  }
});

// Check for updates every 60 minutes
setInterval(() => {
  serviceWorkerRegistration.checkForUpdates();
}, 60 * 60 * 1000);
